import { render, staticRenderFns } from "./newsChoose.vue?vue&type=template&id=3a08a0ae&"
import script from "./newsChoose.vue?vue&type=script&lang=js&"
export * from "./newsChoose.vue?vue&type=script&lang=js&"
import style0 from "./newsChoose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports